import { motion } from 'framer-motion';

const ProgressBar = ({ progress }: { progress: number }) => {
  return (
    <div className="fixed top-16 left-0 right-0 h-1 md:h-1.5 bg-border z-99 md:z-999">
      <motion.div
        className="h-full bg-[#0066B2]"
        initial={{ width: 0 }}
        animate={{ width: `${progress}%` }}
        transition={{ duration: 0.3 }}
      />
    </div>
  );
};

export default ProgressBar;
